import { z } from '@hono/zod-openapi'

export const LESSON_START_STYLES = ['SKIP_INTRO', 'WITH_INTRO'] as const

export const lessonStartStyleSchema = z.enum(LESSON_START_STYLES)

export const lessonStartStyleResponseSchema = z.object({
  lessonStartStyle: lessonStartStyleSchema,
  isSet: z.boolean(),
})

export const updateLessonStartStyleRequestSchema = z.object({
  lessonStartStyle: lessonStartStyleSchema,
})

export type LessonStartStyle = z.infer<typeof lessonStartStyleSchema>
export type LessonStartStyleResponse = z.infer<typeof lessonStartStyleResponseSchema>
export type UpdateLessonStartStyleRequest = z.infer<typeof updateLessonStartStyleRequestSchema>
